export const UiStoreKeys = {
  ThemeMode: "ui:themeMode",
  SidebarCollapsed: "ui:sidebarCollapsed",
}
